import { render } from "./login-footer.vue?vue&type=template&id=6bba7fd3&scoped=true"
import script from "./login-footer.vue?vue&type=script&lang=js"
export * from "./login-footer.vue?vue&type=script&lang=js"

import "./login-footer.vue?vue&type=style&index=0&id=6bba7fd3&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bba7fd3"]])

export default __exports__